var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import DefaultLayer from './default_layer';
import { useSelector, useDispatch } from 'react-redux';
import { layerAction } from '../../reducers/layer';
import LoadScript from 'common/modules/loadScript';
var Share = function () {
    var item = useSelector(function (state) { return state.product.item; });
    var _a = useState(false), isCopy = _a[0], setIsCopy = _a[1];
    var dispatch = useDispatch();
    var title = '쇼핑 큐레이션 · 행복쇼핑';
    var description = '행복쇼핑은 컴퓨터, 조립PC에 특화된 온라인 견적 가격비교 사이트 입니다. 안전구매시스템(전자보증,에스크로)을 갖춘 쇼핑몰, 미니샵의 최저 가격 정보를 보여드립니다. 쇼핑의 행복! 행복쇼핑';
    var imageUrl = "".concat(process.env.REACT_APP_CDN_IMG, "/img_static/img_pres/_v3/kakao_002.jpg");
    var url = window.location.href;
    var closedLayer = function () {
        dispatch(layerAction({
            name: null,
            data: null
        }));
    };
    var snsKakaoTalk = function () {
        window.Kakao.Link.sendDefault({
            objectType: 'feed',
            content: {
                title: title,
                description: description,
                imageUrl: imageUrl,
                imageWidth: 1200,
                imageHeight: 625,
                link: {
                    mobileWebUrl: url,
                    webUrl: url,
                },
            },
            buttons: [
                {
                    title: '행복쇼핑에서 보기',
                    link: {
                        mobileWebUrl: url,
                        webUrl: url,
                    },
                },
            ],
        });
    };
    var snsKakaoStory = function () {
        window.open("https://story.kakao.com/share?url=".concat(url), 'snsPop', 'toolbar=yes,scrollbars=yes,resizable=yes,top=100,left=100,width=400,height=600');
    };
    var snsFaceBook = function () {
        window.open("http://www.facebook.com/sharer/sharer.php?u=".concat(url), 'snsPop', 'toolbar=yes,scrollbars=yes,resizable=yes,top=100,left=100,width=500,height=600');
    };
    var snsLine = function () {
        var text = encodeURIComponent(title);
        window.open("http://line.me/msg/text/?".concat(text, " : ").concat(url), 'snsPop', 'toolbar=yes,scrollbars=yes,resizable=yes,top=100,left=100,width=600,height=500');
    };
    var snsTwitter = function () {
        var text = encodeURIComponent(title);
        window.open("//twitter.com/share?text=".concat(text, "&url=").concat(url), 'snsPop', 'toolbar=yes,scrollbars=yes,resizable=yes,top=100,left=100,width=650,height=500');
    };
    var onClickCopyUrl = function () {
        var url = document.querySelector('#copyurl');
        url.select();
        document.execCommand('Copy');
        setIsCopy(true);
    };
    useEffect(function () {
        LoadScript('https://developers.kakao.com/sdk/js/kakao.min.js').then(function () {
            // 2022-08-30 앱키 변경
            window.Kakao.init('d98008c5b7924c032845dea5e5d12b26');
        });
    });
    return (React.createElement(DefaultLayer, null,
        React.createElement(Content, null,
            React.createElement("div", { className: "shareSnsPop" },
                React.createElement("strong", { className: "popName" }, "\uACF5\uC720\uD558\uAE30"),
                React.createElement("div", { className: "shareSnsList" },
                    React.createElement("button", { type: "button", onClick: snsKakaoTalk },
                        React.createElement("img", { src: "".concat(process.env.REACT_APP_CDN_IMG, "/img_static/img_mobile/comm/sns_kakaotalk.png"), alt: "\uCE74\uCE74\uC624\uD1A1" }),
                        React.createElement("span", null, "\uCE74\uCE74\uC624\uD1A1")),
                    React.createElement("button", { type: "button", onClick: snsLine },
                        React.createElement("img", { src: "".concat(process.env.REACT_APP_CDN_IMG, "/img_static/img_mobile/comm/sns_line.png"), alt: "\uB77C\uC778" }),
                        React.createElement("span", null, "\uB77C\uC778")),
                    React.createElement("button", { type: "button", onClick: snsFaceBook },
                        React.createElement("img", { src: "".concat(process.env.REACT_APP_CDN_IMG, "/img_static/img_mobile/comm/sns_facebook.png"), alt: "\uD398\uC774\uC2A4\uBD81" }),
                        React.createElement("span", null, "\uD398\uC774\uC2A4\uBD81")),
                    React.createElement("button", { type: "button", onClick: snsKakaoStory },
                        React.createElement("img", { src: "".concat(process.env.REACT_APP_CDN_IMG, "/img_static/img_mobile/comm/sns_kakaostory.png"), alt: "\uCE74\uCE74\uC624\uC2A4\uD1A0\uB9AC" }),
                        React.createElement("span", null, "\uCE74\uCE74\uC624\uC2A4\uD1A0\uB9AC")),
                    React.createElement("button", { type: "button", onClick: snsTwitter },
                        React.createElement("img", { src: "".concat(process.env.REACT_APP_CDN_IMG, "/img_static/img_mobile/comm/sns_twitter.png"), alt: "\uD2B8\uC704\uD130" }),
                        React.createElement("span", null, "\uD2B8\uC704\uD130"))),
                React.createElement("div", { className: "shareUrl" },
                    React.createElement("input", { type: "text", id: "copyurl", className: "copyurl", defaultValue: url }),
                    React.createElement("button", { type: "button", className: "btn_urlcopy", onClick: onClickCopyUrl }, "URL\uBCF5\uC0AC"),
                    isCopy && React.createElement("b", null, "URL\uC774 \uBCF5\uC0AC\uB418\uC5C8\uC2B5\uB2C8\uB2E4.")),
                React.createElement("div", { className: "buttons" },
                    React.createElement("button", { className: "button type1", onClick: closedLayer }, "\uD655\uC778"))))));
};
var Content = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    .popName {\n        font-size: 20px;\n        border-bottom: 1px solid #333;\n        display: block;\n        padding: 0 0 5px;\n    }\n    .buttons {\n        justify-content: center;\n\n        .button {\n            flex: none;\n            width: 120px;\n        }\n    }\n"], ["\n    .popName {\n        font-size: 20px;\n        border-bottom: 1px solid #333;\n        display: block;\n        padding: 0 0 5px;\n    }\n    .buttons {\n        justify-content: center;\n\n        .button {\n            flex: none;\n            width: 120px;\n        }\n    }\n"])));
export default Share;
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/layer/share.tsx
// module id = 287
// module chunks = 0